'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dateFns = require('date-fns');

var _type = require('../type');

var _type2 = _interopRequireDefault(_type);

var _customDateTimeParser = require('../customDateTimeParser.types');

var _customDateTimeParser2 = _interopRequireDefault(_customDateTimeParser);

var _time = require('./helpers/time.converter');

var _time2 = _interopRequireDefault(_time);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var format = function format(value) {
  if (!value) return '';
  var dateObj = (0, _dateFns.isDate)(value) ? value : (0, _dateFns.parse)((0, _customDateTimeParser2.default)(value));
  var formattedDate = (0, _dateFns.format)(dateObj, 'ddd h:mma');
  return (0, _time2.default)(dateObj, formattedDate).slice(0, -1);
};

var validate = function validate() {
  return true;
};

exports.default = (0, _type2.default)({
  type: 'string',
  format: format,
  validate: validate
});